import { Divider, Stack, Typography } from '@mui/material';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { useTranslatedText } from 'hooks/useTranslatedText';
import { type Ticket } from 'restful/tickets';
import { getPaidCatalogueAddons } from 'restful/tickets/addon.utils';

import TicketAddonRow from 'components/@events/EventDetailCartContainer/TicketAddonRow';
import TicketPerkList from 'components/@events/EventDetailCartContainer/TicketPerkList';

interface Props {
  ticket: Ticket;
}

const TicketInquiryDetails = ({ ticket }: Props) => {
  const localize = useTranslatedText();
  const description = localize(ticket.description);
  const paidAddons = getPaidCatalogueAddons(ticket);

  return (
    <Stack
      sx={{
        gap: 3,
      }}
    >
      {!!description && (
        <Typography
          variant="small"
          sx={{
            color: 'text.secondary',
          }}
        >
          {description}
        </Typography>
      )}

      <TicketPerkList perks={ticket.perks} />

      {!!paidAddons.length && (
        <Stack
          sx={{
            gap: 1,
          }}
        >
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{
              color: 'common.white',
            }}
          >
            <FormattedMessage id="tickets.cart.addons.label" />
          </Typography>
          <Stack
            sx={{
              gap: 2,
            }}
          >
            {paidAddons.map((addon, index) => (
              <Fragment key={addon.id}>
                <TicketAddonRow
                  addon={addon}
                  parentQuantity={0}
                  quantity={0}
                  canSelect={false}
                />
                {index < paidAddons.length - 1 && (
                  <Divider sx={{ borderColor: 'divider' }} />
                )}
              </Fragment>
            ))}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default TicketInquiryDetails;
